import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import VueToast from 'vue-toast-notification';
import * as Sentry from '@sentry/browser';
import linkify from 'vue-linkify';
import { Vue as VueIntegration } from '@sentry/integrations';
import Carousel3d from 'vue-carousel-3d';
import VueNativeNotification from 'vue-native-notification'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import StarRating from 'vue-star-rating'
import '@stripe/stripe-js';
// import drag from 'v-drag';
// import VueDraggableResizable from 'vue-draggable-resizable'
require('dotenv').config();
AOS.init();

Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
})
// Vue.use(drag)
// Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.use(Carousel3d);
Vue.component('star-rating', StarRating);
import 'vue-toast-notification/dist/theme-default.css';
// import 'vue-toast-notification/dist/theme-sugar.css';
Vue.config.productionTip = false
let AddToCalendar = require('vue-add-to-calendar');
Vue.use(AddToCalendar);
Vue.use(VueToast);
Vue.use(require('vue-moment'));
Vue.directive('linkified', linkify)
import { VuejsDatatableFactory } from 'vuejs-datatable';
Vue.use( VuejsDatatableFactory );
import Multiselect from 'vue-multiselect';
import DragItDude from 'vue-drag-it-dude'
import vuetify from './plugins/vuetify';

Vue.component('vue-drag-it-dude', DragItDude)

Vue.component('multiselect', Multiselect)
Sentry.init({
  dsn: 'https://31d9d1cbff304b348f45e3b1b8012ccd@o397596.ingest.sentry.io/5252193',
  integrations: [new VueIntegration({Vue, attachProps: true})],
});
let app = '';
const config = {
  apiKey: "AIzaSyDLmkS9D2zGI3RrUELvOQnnjT6EanObLTg",
  authDomain: "meet-up-db9b4.firebaseapp.com",
  databaseURL: "https://meet-up-db9b4.firebaseio.com",
  projectId: "meet-up-db9b4",
  storageBucket: "meet-up-db9b4.appspot.com",
  messagingSenderId: "421151927650",
  appId: "1:421151927650:web:db3cc93f2a45185e35d03b",
  measurementId: "G-GDPMBBMZQZ"
};

firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
  }
});
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')
